const EARTH_RADIUS_METERS = 6371000

const toRadians = (value: number): number => (value * Math.PI) / 180

export const calculateDistanceInMeters = (
  originLatitude: number,
  originLongitude: number,
  targetLatitude: number,
  targetLongitude: number,
): number => {
  const latitudeDifference = toRadians(targetLatitude - originLatitude)

  const longitudeDifference = toRadians(targetLongitude - originLongitude)

  const firstPointLatitude = toRadians(originLatitude)

  const secondPointLatitude = toRadians(targetLatitude)

  const haversineValue =
    Math.sin(latitudeDifference / 2) ** 2 +
    Math.cos(firstPointLatitude) * Math.cos(secondPointLatitude) * Math.sin(longitudeDifference / 2) ** 2

  const centralAngle = 2 * Math.atan2(Math.sqrt(haversineValue), Math.sqrt(1 - haversineValue))

  return EARTH_RADIUS_METERS * centralAngle
}
